import Config from 'config/settings';
import { particles } from 'app/contracts/Particles';
import { RepellType } from 'app/enum/Particles';
import { HomeParticle } from 'app/views/home/webgl/particles/fields/HomeParticle';
import HomeColours from 'app/views/home/config/HomeColours';
import { device } from 'utils/device';

export default class IntroParticleProcessor {
	constructor(
		private _p: HomeParticle,
		private _sceneProps: particles.ParticlesSceneProps
	) {}

	public centerPosition(isMobile = false) {
		let x = isMobile ? 0.125555 : 0.1666;

		let position = {
			x: x,
			y: 0.5
		};

		this._p.position.set(position, true);
	}

	/** When first setting up this is the start state  */
	public startState(isMobile = false) {
		this._p.deactivateAllBehaviours(true);
		this._p.activate();
		this._p.position.disableTimelineX = true;


		this.centerPosition(isMobile);

		this._p.particleProps.sprite.blendMode = 'add';

		this._p.animatedProps.alpha = this._p.animatedProps.targetAlpha = 0;
		this._p.animatedProps.scale = this._p.animatedProps.targetScale = 0;
		this._p.repell.active = false;
		this._p.repell.target = this._sceneProps.targets.mouse;
		this._p.repell.type = RepellType.PUSH;
		this._p.repell.radius = 20;
		this._p.repell.randomisePower(10, 20);



		let ease = 1 + Math.random() * 7;
		this._p.animatedProps.setEase({
			scale: 10,
			alpha: 10,
			x: ease,
			y: ease
		});


		let r = 70;
		this._p.setupPath(this._p.orbitPath, {
			x: [r, 10],
			y: [r, 10],
			speed: [0.02, 0.6],
			scale: [0.05, 0.2],
			alpha: [0.03, 0.2],
			randomise: { unsync: true }
		});

		this._p.orbitPath.expandMuliplier = 0;
		this._p.orbitPath.scaleAffect = false;
		this._p.orbitPath.speedMuiliplier = this._p.random(1, 2);

		this._p.counter.millsecsToFrames(1100 + Math.random() * 400);
		this._p.counter.onTrigger = () => {
			this._p.orbitPath.expandMuliplier = 1;

			if (Math.random() < 0.35) {
				this._p.orbitPath.expandMuliplier = 1;
			} else {
				this._p.orbitPath.expandMuliplier = 0.8;
			}

			if (isMobile) {
				this._p.animatedProps.targetAlpha = this._p.random(0.2, 0.35);

				if (Math.random() < 0.95) this._p.animatedProps.targetScale = this._p.random(0.07, 0.35);
				else this._p.animatedProps.targetScale = this._p.random(0.07, 0.47);
			} else {
				if (Math.random() < 0.9) {
					this._p.animatedProps.targetScale = this._p.random(0.07, 0.25);
					this._p.animatedProps.targetAlpha = this._p.random(0.1, 0.5);
				} else {
					this._p.animatedProps.targetScale = this._p.random(0.07, 0.5);
					this._p.animatedProps.targetAlpha = this._p.random(0.1, 0.1);
				}
			}
		};
		this._p.counter.active = true;
		this._p.counter.start();

		this._p.orbitPath.scaleActive = false;

		if (Math.random() < 0.3) {
			this._p.colour.set(HomeColours.getRandomColour(HomeColours.greenBlues));
		} else {
			this._p.colour.set('#ffffff');
		}
	}

	/** When mouse over interaction point this runs  */
	public mouseOver(): void {
		//If Particle has been selected for the range that get attracted to around the circle circle:
		//Otherwise just leave hidden on the grid:

		//Deactivate normal parallax positioning:

		//Attract to center:

		if (Math.random() < 0.5) {
			this._p.colour.set(HomeColours.getRandomColour(HomeColours.greenBlues));
		} else {
			this._p.colour.set('#ffffff');
		}

		if (Math.random() < 0.09) {
			this._p.orbitPath.expandMuliplier = 0.9 + Math.random() * 0.65;
		} else {
			this._p.orbitPath.expandMuliplier = 0.9 + Math.random() * 0.3;
		}

		this._p.orbitPath.speedMuiliplier = 2 + Math.random() * 5;

		this._p.animatedProps.targetAlpha = this._p.random(0.1, 0.45);

		if (Math.random() < 0.95) this._p.animatedProps.targetScale = this._p.random(0.03, 0.45);
		else this._p.animatedProps.targetScale = this._p.random(0.07, 0.9);

		this._p.animatedProps.setEase({
			scale: 20
		});

		return;

		//Repell from the center of the screen around the edge bounday of a radius:
		this._p.repell.active = true;
		this._p.repell.target = this._sceneProps.targets.mouse;
		this._p.repell.type = RepellType.BOUNDARY;
		this._p.repell.testAtCount = 1;
		//Allow for 150px circle and very tight ring:
		this._p.repell.radius = 80;
		this._p.repell.randomisePower(65, 20);

		this._p.animatedProps.setEase({ x: 4, y: 4 });

		//Activate the orbit path to create black hole effect around the intial hover element:
		//The orbit path also makes the scale of the particle

		this._p.animatedProps.targetAlpha = 0.2 + Math.random() * 0.2;

	}

	public mouseOut(): void {
		if (Math.random() < 0.3) {
			this._p.colour.set(HomeColours.getRandomColour(HomeColours.greenBlues));
		} else {
			this._p.colour.set('#ffffff');
		}

		if (Math.random() < 0.35) {
			this._p.orbitPath.expandMuliplier = 1;
		} else {
			this._p.orbitPath.expandMuliplier = 0.8;
		}

		this._p.orbitPath.speedMuiliplier = this._p.random(1, 2);
		if (Math.random() < 0.9) {
			this._p.animatedProps.targetScale = this._p.random(0.07, 0.25);
			this._p.animatedProps.targetAlpha = this._p.random(0.1, 0.5);
		} else {
			this._p.animatedProps.targetScale = this._p.random(0.07, 0.5);
			this._p.animatedProps.targetAlpha = this._p.random(0.1, 0.1);
		}

		this._p.animatedProps.setEase({
			scale: 10,
			alpha: 10
		});

	}

	public introComplete() {
		this._p.counter.active = false;

		let mobile = device.innerWidth < Config.mobileBreakpoint;
		let maxExpand = mobile ? 2 : 4;

		let maxExpandBig = mobile ? 2.5 : 5;

		let maxScale = mobile ? 0.22 : 0.17;

		this._p.animatedProps.setEase({
			scale: 30,
			alpha: 30,
			x: 30,
			y: 30
		});

		if (Math.random() < 0.5) {
			this._p.orbitPath.expandMuliplier = 2 + Math.random() * maxExpandBig;

			this._p.orbitPath.speedMuiliplier = 0;
			this._p.animatedProps.targetAlpha = 0;
			this._p.animatedProps.targetScale = 0;

			setTimeout(
				() => {
					this._p.setActive(false);
				},
				1000 + Math.random() * 1000
			);
		} else {
			this._p.orbitPath.expandMuliplier = 2 + Math.random() * maxExpand;
			this._p.orbitPath.speedMuiliplier = 0;
			this._p.animatedProps.targetAlpha = 0.2 + Math.random() * 0.2;
			this._p.animatedProps.targetScale = 0.06 + Math.random() * maxScale;

			setTimeout(
				() => {
					this._p.animatedProps.targetAlpha = 0;
					this._p.animatedProps.targetScale = 0;
				},
				1000 + Math.random() * 600
			);

			setTimeout(
				() => {
					this._p.setActive(false);
				},
				2000 + Math.random() * 1000
			);
		}
	}
}
